/**
 * Consent to run a site's uploaded design system on this device.
 *
 * The code runs in an isolated sandbox, but it is still someone else's code
 * running here, so a collaborator is asked once per RELEASE: consent names
 * the manifest hash, and a new release (another hash) asks again. The owner
 * installed it and never needs asking.
 *
 * Per viewer and per device: browser storage is right for that, and losing it
 * (private window, cleared data) only means being asked again.
 */
const key = (siteId: string) => `wb.ds-consent.${siteId}`;

export function hasConsented(siteId: string, manifestSha: string): boolean {
  try {
    return localStorage.getItem(key(siteId)) === manifestSha;
  } catch {
    return false;
  }
}

export function recordConsent(siteId: string, manifestSha: string): void {
  try {
    localStorage.setItem(key(siteId), manifestSha);
  } catch {
    // Storage unavailable: consent holds for this session's state only.
  }
}
